import lessRequire from '../../../../config/less-require-resolver';
import PropTypes from 'prop-types';
import React from 'react';
import { Field, reduxForm } from 'redux-form';
import classname from 'classname';

import ComplaintForm from '../../../shared/complaint-form';
import TextAreaField from '../../../shared/form-elements/textarea';
import AttachmentsField from '../../../shared/form-elements/attachments';

lessRequire('modules/tickets/item/components/form.less');

class Form extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		const {
			handleSubmit,
			addFileToUpload,
			removeFileFromUpload,
			uploadError,
			createAnswer,
			filesToUpload,
			isClosed,
			formData,
			user,
			intl,
			createTicket
		} = this.props;
		return (
			<form
				action="#"
				className="ticket-item-form clearfix"
				onSubmit={handleSubmit(data => {
					if (formData.isFromAdmin) {
						if (!confirm(intl('Вы пытаетесь добавить ответ от веба. Уверены?'))) {
							return;
						}
					}
					return !isClosed ? createAnswer(data) : createTicket(data);
				})}
			>
				<div>
					<div className="tickets-form__row">
						<Field name="text" component={TextAreaField} placeholder={intl('Текст сообщения')} />
					</div>

					<div className="tickets-form__row upload-row">
						<Field
							name="file"
							component={AttachmentsField}
							placeholder={intl('Прикрепить файл')}
							info={intl('Общий размер загруженных файлов не более 5 МБ')}
							addFileToUpload={addFileToUpload}
							removeFileFromUpload={removeFileFromUpload}
							files={filesToUpload}
							maxSizeError={uploadError}
							externalKey={formData.fileInputKey}
							intl={intl}
						/>
					</div>

					<div className="tickets-form__row tickets-row">
						<button
							className={classname({
								'button font-proxima-nova-semibold': true,
								'yellow-btn': true
							})}
						>
							{intl('Отправить тикет')}
						</button>

						<p className="manager__remarks">
							{intl('Если у вас есть замечания по работе')}&nbsp;
							{intl('менеджера, пожалуйста,')}{' '}
							<a
								href="#"
								onClick={e => {
									e.preventDefault();
									this.form.toggleModal();
								}}
							>
								{intl('напишите нам')}
							</a>
						</p>
					</div>

					<ComplaintForm user={user} intl={intl} ref={form => (this.form = form)} />
				</div>
			</form>
		);
	}
}

Form.propTypes = {
	handleSubmit: PropTypes.func,
	addFileToUpload: PropTypes.func,
	removeFileFromUpload: PropTypes.func,
	filesToUpload: PropTypes.array,
	uploadError: PropTypes.bool,
	createAnswer: PropTypes.func,
	isClosed: PropTypes.bool,
	formData: PropTypes.object,
	user: PropTypes.object,
	intl: PropTypes.func,
	createTicket: PropTypes.func
};

export default reduxForm({
	form: 'answerTicketForm'
})(Form);



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/tickets/item/components/form.js